module.exports = __webpack_public_path__ + "5ef81fb012b109f997c409a226aa0a04.pdf";